import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton, MiIcon } from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const EmptyPurchaseOrders = memo(({ onAddPurchaseOrder }) => {
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconContainer}>
        <MiIcon
          path={mdi[ICONS_WEB.DOCUMENT]}
          color={theme.palette.grey.main}
        />
      </Box>
      <Typography className={classes.title}>No Payment Information</Typography>
      <Typography className={classes.description}>
        Uploaded payment information will appear here after they have been added
      </Typography>
      <MiButton
        title="Add Payment Information"
        startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
        variant={BUTTON_VARIANTS.CONTAINED}
        onClick={onAddPurchaseOrder}
      />
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: theme.spacing(2),
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    fontWeight: theme.fontWeight.semiBold,
  },
  description: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.grey.medium,
  },
}));
